import { useEffect, useState, useRef } from "react";
import moment from "moment";
import { useLazyQuery } from "@apollo/client";
import Dropdown from "shared/Components/dropdown";
import { MobilePagination } from "shared/Components/mobilePagination";
import { SearchLocation } from "shared/Components/searchLocation";
import { TrailMobileCard } from "./components/MobileCard";
import { DEFAULT_DATE_FORMAT, LEVEL_DROPDOWN_DATA } from "helper/utility";
import { globalVariables } from "helper/globalVariables";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import { globalClasses } from "helper/globalClasses";
import { TrialCalendarQuery } from "redux/features/trialCalendar/trialCalendarGql";
import { PopUpMessages } from "shared/Components/popUpMessages";
import Loader from "shared/Components/loader";
import { ReportsList, TrailStatus } from "./reports.constant";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import {
  DonwloadNoOfEntries,
  DonwloadPassRate,
  DownloadTrialDrawReport,
  DonwloadTrialStatistics,
  DonwloadTrialPremium,
  DonwloadTrialResults,
  DonwloadDogResults,
  DonwloadPotentialTitles,
  DonwloadAllCompetitors,
  DonwloadDogResultsPremier,
} from "./reports.helper";
import { CustomDateRangePicker } from "shared/Components/customDateRangePicker";
import PageInfo from "shared/Components/pageInfo";
import TrialStatisticsReports from "./components/TrialStatistics";
import TrialPremiumReports from "./components/TrialResultsPremium";
import TrialResults from "./components/TrialResults";
import TrialDogResultsPremeir from "./components/TrialDogResultsPremeir";
import TrialDogResults from "./components/TrialDogResults";
import { Button } from "shared/Components/button";

const columns = [
  {
    label: globalVariables.trialName,
    style: "",
  },
  {
    label: globalVariables.date,
    style: "",
  },
  // {
  //   label: globalVariables.location,
  //   style: "pl-0 !text-left",
  // },
  {
    label: globalVariables.city,
    // style: "pl-0 !text-left",
  },
  {
    label: globalVariables.state,
    // style: "pl-0 !text-left",
  },
  // {
  //   label: globalVariables.zipCode,
  //   // style: "pl-0 !text-left",
  // },
  // {
  //   label: globalVariables.level,
  //   style: "pl-0 !text-left",
  // },
  {
    label: globalVariables.openDate,
    style: "",
  },
  {
    label: globalVariables.closeDate,
    style: "",
  },
  {
    label: globalVariables.cutoffDate,
    style: "",
  },
  {
    label: globalVariables.generateReport,
    style: "",
  },
];
const GenerateReports = (props) => {
  const { isHost } = props || {};
  const popUpModalRef = useRef();
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [getData, { loading, error, data }] = useLazyQuery(TrialCalendarQuery);
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const [page, setPage] = useState(1);
  const { paginatedDataCls } = globalClasses;
  const [filters, setFilters] = useState({
    city: "",
    state: "",
    level: "",
    approvalStatus: isHost ? "Approve" : "",
    pageNumber: page,
    pageSize: 10,
    fromDate: null,
    toDate: null,
    role: isHost ? "Host" : "",
  });

  useEffect(() => {
    getData({
      variables: filters,
      fetchPolicy: "no-cache",
    });
  }, [filters, page, getData]);

  const resultData = data?.getAllTrialCalendar;
  const trials = resultData?.data || [];

  const handlePaginationData = (pages = 1) => {
    setPage(pages);
    onChange(pages, "pageNumber");
  };

  const renderButton = (id) => {
    return (
      <>
        {loadingRowId === id ? (
          <Loader />
        ) : (
          <Dropdown
            width={"w-[180px]"}
            placeholder={globalVariables.generateReport}
            dropdownOptions={ReportsList}
            mainContent="w-100%"
            onChange={(option) => onChangeStatus(option, id)}
          />
        )}
      </>
    );
  };

  const onCloseModal = () => {};
  const renderTableBody = () => {
    return trials?.map((trial, index) => {
      return (
        <tr
          key={trial.id}
        >
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {trial?.trial.trialName}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {moment.utc(trial?.trial?.trialDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          {/* <td
            className={`${paginatedDataCls(index)} w-[200px] pl-0 !text-left`}
          >
            {trial?.trial?.trialLocationAddress}
          </td> */}
          <td className={`${paginatedDataCls(index)}`}>{trial?.trial?.city}</td>
          <td className={`${paginatedDataCls(index)}`}>
            {trial?.trial?.state}
          </td>
          {/* <td className={`${paginatedDataCls(index)}`}>{trial?.trial?.zip}</td>
          <td className={`${paginatedDataCls(index)} pl-0 !text-left`}>
            {trial?.search?.map((search) => search?.level).join(", ")}
          </td> */}
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {moment.utc(trial?.trial?.openDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {moment.utc(trial?.trial?.closeDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {trial?.trial?.cutoffDate ? moment.utc(trial?.trial?.cutoffDate).format(DEFAULT_DATE_FORMAT) : "-"}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {renderButton(trial.id)}
          </td>
        </tr>
      );
    });
  };

  const generateStatisticsPDF = async (data) => {
    if (!data) return;
    const doc = <TrialStatisticsReports data={data} />;
    const blob = await pdf(doc).toBlob();
    saveAs(blob, "Trial Statistics Reports.pdf");
  };

  const generatePremiumPDF = async (data) => {
    if (!data) return;
    const doc = <TrialPremiumReports data={data} />;
    const blob = await pdf(doc).toBlob();
    saveAs(blob, globalVariables.trialPremier);
  };

  const generateTrialResultsPDF = async (data) => {
    if (!data) return;
    const doc = <TrialResults data={data} />;
    const blob = await pdf(doc).toBlob();
    saveAs(blob, "Trial Results.pdf");
  };

  const generateDogResultsPDF = async (data) => {
    const doc = <TrialDogResults data={data} />;
    const blob = await pdf(doc).toBlob();
    setLoadingRowId(null);
    saveAs(blob, "Report Dog Results.pdf");
  };

   const generateTrialResultsPremeirPDF = async (data) => {
    const doc = <TrialDogResultsPremeir results={data} />;
    const blob = await pdf(doc).toBlob();
    setLoadingRowId(null);
    saveAs(blob, "Report Dog Results Premeir.pdf");
  };

  const generatePotentialCSV = (data) => {
    let csvRows = [];
    csvRows.push(`Trial Name: ${data.trialName}`);
    csvRows.push("Dog Name,Handler,Search Entered,Div,Qs/Points Earned to Date,Ribbon");

    data.result.forEach(item => {
      const isPremier = item.search?.toLowerCase().includes("premier");
      const progress = isPremier ? item.points || "0" : item.qNumber || "0";
      csvRows.push(`${item.dogName},${item.handler},${item.search},${item.div},${progress},`);
    });

    setLoadingRowId(null);
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "potential_titles_report.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const onChangeStatus = async (value, id) => {
    try {
      switch (value) {
        case globalVariables.finalEntryTelly: {
          setLoadingRowId(id);
          const data = await DonwloadNoOfEntries(id);
           if(!data) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          window.open(data, "_blank");
          setLoadingRowId(null);
          return data;
        }
        case globalVariables.passRate: {
          setLoadingRowId(id);
          const data = await DonwloadPassRate(id);
          if(!data) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          window.open(data, "_blank");
          setLoadingRowId(null);
          return data;
        }
        case globalVariables.competitorList: {
          setLoadingRowId(id);
          const data = await DownloadTrialDrawReport(id);
          if(!data) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          window.open(data, "_blank");
          setLoadingRowId(null);
          return data;
        }
        case globalVariables.trialStatistics: {
          setLoadingRowId(id);
          const data = await DonwloadTrialStatistics(id);
          if(!data.dataExist) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          generateStatisticsPDF(data);
          setLoadingRowId(null);
          return;
        }
        case globalVariables.trialPremier: {
          setLoadingRowId(id);
          const data = await DonwloadTrialPremium(id);
          if(!data.awards & !data.overall && !data.premier) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          generatePremiumPDF(data);
          setLoadingRowId(null);
          return;
        }
        case globalVariables.trialResultsNAE: {
          setLoadingRowId(id);
          const data = await DonwloadTrialResults(id);
          if(data.awards.length < 1 && data.nonPremier.length < 1 && data.sit.length < 1) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          generateTrialResultsPDF(data);
          setLoadingRowId(null);
          return;
        }
        case globalVariables.dogResults: {
          setLoadingRowId(id);
          const data = await DonwloadDogResults(id)
          if(data.result.length < 1) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          generateDogResultsPDF(data);
          return;
        }
        case globalVariables.dogResultsPremier: {
          setLoadingRowId(id);
          const data = await DonwloadDogResultsPremier(id);
          if(!data.data) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          generateTrialResultsPremeirPDF(data);
          return;
        }
        case globalVariables.getPotentialTitles: {
          setLoadingRowId(id);
          const data = await DonwloadPotentialTitles(id);
          if(!data.trialName) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          generatePotentialCSV(data);
          return data;
        }
        case globalVariables.allCompetitorsReport: {
          setLoadingRowId(id);
          const data = await DonwloadAllCompetitors(id);
          if(!data) {
            popUpModalRef.current.openModal();
            setLoadingRowId(null);
            setApiData({
              title: globalVariables.error,
              desc: globalVariables.noRecords,
              type: "pending",
            });
            return;
          }
          window.open(data, "_blank");
          setLoadingRowId(null);
          return data;
        }
        default: {
          console.log("Default Case", value);
        }
      }
    } catch (error) {
      setLoadingRowId(null);
      popUpModalRef.current.openModal();
      setApiData({
        title: "Error",
        desc: error.message || "An error occurred while generating the report",
        type: "pending",
      });
    }
  };

  const onChange = (value, key) => {
    setFilters({
      ...filters,
      [key]: value,
    });
  };
  
  const onClearFilters = () => {
    setFilters((prev) => ({
      ...prev,
      fromDate: null,
      toDate: null,
      city: "",
      state: "",
      level: "",
    }));
  };

  return (
    <div ref={popUpModalRef} className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
        <PageInfo  title={globalVariables.generateReport}>
          <Button
            width={"w-auto"}
            label="Clear All Filters"
            onClick={onClearFilters} 
          />
        </PageInfo>
        <div className={`grid md:grid-cols-2 ${!isHost ? "lg:grid-cols-5" : "lg:grid-cols-4"} gap-5 my-5`}>
          <CustomDateRangePicker
            defaultStartDate={filters.fromDate}
            defaultEndDate={filters.toDate}
            isShadow={true}
            width={"w-full"}
            onSetDate={(startDate, endDate) => {
              setFilters({
                ...filters,
                fromDate: startDate
                  ? moment(startDate).startOf("month").format("YYYY-MM-01")
                  : null,
                toDate: endDate
                  ? moment(endDate).endOf('month').format("YYYY-MM-DD")
                  : null,
              });
            }}
          />
          <SearchLocation
            isShadow={true}
            width={"w-full"}
            name="State"
            placeholder={globalVariables.state}
            types={["(regions)"]}
            onSelectLocation={(location) => {
              onChange(location, "state");
            }}
            defaultValue={filters.state}
          />
          <SearchLocation
            isShadow={true}
            width={"w-full"}
            name="city"
            placeholder={globalVariables.city}
            types={["(cities)"]}
            onSelectLocation={(location) => {
              onChange(location, "city");
            }}
            searchBy={filters.state}
            defaultValue={filters.city}
          />
          <Dropdown
            defaultOption={filters.level}
            isShadow={true}
            width={"w-full"}
            placeholder={globalVariables.level}
            dropdownOptions={LEVEL_DROPDOWN_DATA}
            showIconLeft={true}
            showCross
            onChange={(option) => {
              onChange(option, "level");
            }}
          />
          {!isHost && (
            <Dropdown
              isShadow={true}
              width={"w-full"}
              placeholder={globalVariables.trailStatus}
              dropdownOptions={TrailStatus}
              showIconLeft={true}
              showCross
              onChange={(option) => onChange(option, "approvalStatus")}
            />
          )}
        </div>
        <div className={`mt-[20px] md:hidden`}>
          <>
            {!loading && !error && (
              <div className="mt-[20px]">
                <div className="pb-[12px]">
                  {trials?.map((data, index) => (
                    <TrailMobileCard
                      data={data}
                      key={index.toString()}
                      index={index}
                      onChangeStatus={(option) =>
                        onChangeStatus(option, data?.id)
                      }
                      loadingRowId={loadingRowId}
                      statusLoading={false}
                      onClick={() => {}}
                      renderBtn={(id) => renderButton(id)}
                    />
                  ))}
                </div>
                {resultData?.totalPages > 1 ? (
                  <MobilePagination
                    currentPage={resultData?.pageNumber}
                    totalPages={resultData?.totalPages}
                    handlePageChange={(page) => handlePaginationData(page)}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </>
        </div>
        <div className="hidden md:block md:mt-[16px] lg:block lg:mt-8">
          <TableWithPagination
            headData={columns}
            headDateWithStyle={true}
            tableBody={renderTableBody()}
            loading={loading}
            error={error}
            isHeaderComponentRow={true}
            itemsPerPage={10}
            totalPage={resultData?.totalPages}
            handlePageChange={(page) => handlePaginationData(page)}
            tableHeight={"md:h-[calc(100vh-15rem)] lg:h-[100vh]"}
          />
        </div>
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={popUpModalRef}
        onCloseModal={onCloseModal}
      />
    </div>
  );
};
export default GenerateReports;
